<template>
	<div>
		d
	</div>
</template>

<script>
	
	import axios from 'axios'

	export default {
		name: 'system-export',

		
		data() {
			return {

				www: [],
			}
		},
		created() {
			// this.importClothCategoryPrices()
		},

		methods: {

			importProducts() {
				axios.get('https://dev.perpao.com/api/export/products')
				.then(response => {
					this.www = response.data
					console.log(this.items)
					// this.exportProducts()

				})
				.catch(error => {
					console.log(error)
				})
				
			},

			exportProducts() {
				axios.post(this.$store.getters.getDomainName+'system/import/products', {
					www: this.www
				})
				.then(response => {

				console.log(response.data)
			})
				.catch(error => {

				})

			},
			importCloths() {
				axios.get('https://dev.perpao.com/api/export/cloths')
				.then(response => {
					this.www = response.data
					console.log(this.items)
					this.exportCloths()

				})
				.catch(error => {
					console.log(error)
				})
				
			},
			exportCloths() {
				axios.post(this.$store.getters.getDomainName+'system/import/cloths', {
					www: this.www
				})
				.then(response => {

					console.log(response.data)

				})
				.catch(error => {

				})

			},

			importClothCategories() {
				axios.get('https://dev.perpao.com/api/export/cloth/categories')
				.then(response => {
					this.www = response.data
					console.log(this.items)
					// this.exportClothCategories()

				})
				.catch(error => {
					console.log(error)
				})
				
			},
			exportClothCategories() {
				axios.post(this.$store.getters.getDomainName+'system/import/cloth/categories', {
					www: this.www
				})
				.then(response => {

					console.log(response.data)

				})
				.catch(error => {

				})

			},

			importClothCategoryPrices() {
				axios.get('https://dev.perpao.com/api/export/cloth/category/prices')
				.then(response => {
					this.www = response.data
					console.log(this.items)
					// this.exportClothCategoryPrices()

				})
				.catch(error => {
					console.log(error)
				})
				
			},
			exportClothCategoryPrices() {
				axios.post(this.$store.getters.getDomainName+'system/import/cloth/category/prices', {
					www: this.www
				})
				.then(response => {

					console.log(response.data)

				})
				.catch(error => {

				})

			},

			

		},

		

	}

</script>


// WEBPACK FOOTER //
// src/components/system/export.vue